import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ApiEndpoints } from '../../config/api-endpoints';
import { environment } from '../../environments/environment';
import { IClaim, ISummary, IMsgSummary, ClaimIdsModel, ClaimListModel, MessageClaimIdsModel, MessageListModel, MessageIdsModel, ILayoutDetails, ClaimStats, GetUserLayoutDetails, GetUserLayout, removeUserLayout, RedirectDetails, IMultiClaimDetail, IUpdateClaimDetailsResponse, IValidateClaimsRequest, IValidateClaimsResponse, IUploadDocumentRequest, IUploadDocumentResponse, ISubmitClaimRequest, ISubmitClaimResponse, IUploadSubDocumentResponse, IDeleteSubDocumentResponse } from '../shared/models/claim.interface';
import { DecimalPipe } from '@angular/common';
import { UserService } from './user.service';
import { ReopenClaim } from '../shared/models/reopen-claim.interface';
import { DeleteDraft } from '../shared/models/delete-draft.interface';
import { PolicyService } from './policy.service';
import { LoginService } from './login.service';
import { Router } from '@angular/router';

@Injectable()
export class ClaimService {

  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };
  private subject = new Subject<any>();
  private setCurrentStep = new Subject<any>();
  private addressValidationData = new BehaviorSubject<any>(null);
  private tupssEnteredAddress = new BehaviorSubject<any>(null);
  private loading = new BehaviorSubject<boolean>(false);
  private iShipData = new BehaviorSubject<any>(null);
  private tupssClaimData = new BehaviorSubject<any>(null);
  private isClaimSearchCompleted = new BehaviorSubject<boolean>(true);  //right now only used in SSP searches to communicate between components
  currentPartner: string = ''; // current partner for font
  partnerDetails; //getClaimStats Duplicate API calls

  constructor(
    private http: HttpClient,
    private number: DecimalPipe,
    private userService: UserService,
    private policyService: PolicyService,
    private loginService: LoginService,
    private router: Router
  ) {

    try {
      this.partnerDetails = JSON.parse(sessionStorage.getItem('partnerDetails'));
      if (this.partnerDetails !== null) {
        this.currentPartner = this.partnerDetails.portalType; //getClaimStats Duplicate API calls
        console.log("Current Partner 9876", this.currentPartner);
      }
    } catch (error) {
      console.log("Error retrieving partner details from session storage", error);
    }
  }
  // Unused API
  // public getClaim(id: string): Observable<IClaim> {
  //   return this.http.get<IClaim>(`${environment.baseUrl.api}${ApiEndpoints.getClaim}?id=${id}`);
  // }

  clearFilters() {
    this.subject.next(true);
  }

  setStep() {
    let data = {
      a: event,
      b: 1,
    }
    this.setCurrentStep.next(data);
  }

  getStepValue(): Observable<any> {
    return this.setCurrentStep.asObservable();
  }
  clearStorage() {
    sessionStorage.removeItem('isSearchMade');
    sessionStorage.removeItem('amountSearch');
    sessionStorage.removeItem('claimStatusSearch');
    sessionStorage.removeItem('dateSearch');
    sessionStorage.removeItem('isdefault');
    sessionStorage.removeItem('retainState');
    sessionStorage.removeItem('searchFilters');
    sessionStorage.removeItem('isPostBack');
    sessionStorage.removeItem('defaultType');
    sessionStorage.removeItem('receiverInfo');
    sessionStorage.removeItem('accountInfo');
  }
  getResetValue(): Observable<any> {
    return this.subject.asObservable();
  }
  public saveClaim(claim: IClaim): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl.api}${ApiEndpoints.saveClaim}`, claim, this.httpOptions);
  }

  public createClaim(claim: IClaim): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl.api}${ApiEndpoints.createClaim}`, claim, this.httpOptions);
  }

  public submitClaim(claim: IClaim): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl.api}${ApiEndpoints.submitClaim}`, claim, this.httpOptions);
  }

  public getImportedFile(request: { PolicyNo: string; GroupCode: string | null; StartDate: string; EndDate: string }): Observable<any> {
    return this.http.post<any>(
      `${environment.baseUrl.api}${ApiEndpoints.getImportedFile}`,
      request,
      this.httpOptions
    ).pipe(
      map((response) => {
        if (typeof response === 'string') {
          try {
            return JSON.parse(response);
          } catch {
            return response;
          }
        }

        return response;
      })
    );
  }

  public downloadTemplate(policyNo: string): Observable<any> {
    return this.http.get(`${environment.baseUrl.api}${ApiEndpoints.templateDownload}?policyNo=${encodeURIComponent(policyNo || '')}`, {
      observe: 'response',
      responseType: 'blob'
    });
  }

  public submitExportExcel(fileImportID: number | string): Observable<any> {
    return this.http.get(
      `${environment.baseUrl.api}${ApiEndpoints.submitExportExcel}?fileImportID=${encodeURIComponent(String(fileImportID || ''))}`,
      {
        observe: 'response',
        responseType: 'blob'
      }
    );
  }

  public cancelExportExcel(fileImportID: number | string): Observable<any> {
    return this.http.get(
      `${environment.baseUrl.api}${ApiEndpoints.cancelExportExcel}?fileImportID=${encodeURIComponent(String(fileImportID || ''))}`,
      {
        observe: 'response',
        responseType: 'blob'
      }
    );
  }

  public cancelUpload(fileImportID: number | string, policyNo?: string): Observable<any> {
    return this.http.get<any>(
      `${environment.baseUrl.api}${ApiEndpoints.cancelUpload}?fileImportID=${encodeURIComponent(String(fileImportID || ''))}&policyNo=${encodeURIComponent(policyNo || '')}`,
      this.httpOptions
    ).pipe(
      map((response) => {
        if (typeof response === 'string') {
          try {
            return JSON.parse(response);
          } catch {
            return response;
          }
        }

        return response;
      })
    );
  }

  public refreshData(claimFileId: number | string, policyNo: string): Observable<any> {
    return this.http.post<any>(
      `${environment.baseUrl.api}${ApiEndpoints.refreshData}`,
      { ClaimFileId: Number(claimFileId) || 0, PolicyNo: policyNo || '' },
      this.httpOptions
    ).pipe(
      map((response) => {
        if (typeof response === 'string') {
          try {
            return JSON.parse(response);
          } catch {
            return response;
          }
        }

        return response;
      })
    );
  }

  // Confirmed endpoint shape: GET multiClaim/list?fileImportID={id}&policyNo={policyNo} -> { claimDetails: [...] }
  public getReadOnlyList(fileImportId: number | string, policyNumber: string): Observable<any> {
    return this.http.get<any>(
      `${environment.baseUrl.api}${ApiEndpoints.readOnlyList}?fileImportID=${encodeURIComponent(String(fileImportId || ''))}&policyNo=${encodeURIComponent(policyNumber || '')}`
    ).pipe(
      map((response) => {
        if (typeof response === 'string') {
          try {
            return JSON.parse(response);
          } catch {
            return response;
          }
        }

        return response;
      })
    );
  }

  public getSummaryPage(fileImportId: number | string, policyNumber: string): Observable<any> {
    return this.http.get<any>(
      `${environment.baseUrl.api}${ApiEndpoints.summaryPage}?fileImportID=${encodeURIComponent(String(fileImportId || ''))}&policyNo=${encodeURIComponent(policyNumber || '')}`
    );
  }

  public getSuccessPage(claimFileId: number | string): Observable<any> {
    return this.http.get<any>(
      `${environment.baseUrl.api}${ApiEndpoints.successPage}?ClaimFileId=${encodeURIComponent(String(claimFileId || ''))}`
    );
  }

  public getSubmittedList(fileImportId: number | string, policyNumber: string): Observable<any> {
    return this.http.post<any>(
      `${environment.baseUrl.api}${ApiEndpoints.submittedList}`,
      { FileImportID: String(fileImportId || ''), PolicyNo: policyNumber || '' },
      this.httpOptions
    );
  }

  public getUploadedDocumentsDetails(claimFileId: number | string): Observable<any> {
    return this.http.get<any>(
      `${environment.baseUrl.api}${ApiEndpoints.uploadedDocumentsDetails}?ClaimFileId=${encodeURIComponent(String(claimFileId || ''))}`
    );
  }

  public deleteSelected(selectedRecordIds: number[], claimFileId: number | string, policyNo: string): Observable<any> {
    return this.http.post<any>(
      `${environment.baseUrl.api}${ApiEndpoints.deleteSelected}`,
      {
        selectedRecordIds,
        claimFileId: Number(claimFileId) || 0,
        policyNo: policyNo || ''
      },
      this.httpOptions
    ).pipe(
      map((response) => {
        if (typeof response === 'string') {
          try {
            return JSON.parse(response);
          } catch {
            return response;
          }
        }

        return response;
      })
    );
  }

  public withdrawClaim(withdrawnClaim): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl.api}${ApiEndpoints.withdrawClaim}`, { "policyNumber": withdrawnClaim.userPolicyNumber, "claimNumber": withdrawnClaim.userClaimNumber }, this.httpOptions);
  }

  public reopenClaim(claim: ReopenClaim): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl.api}${ApiEndpoints.reopenClaim}`, claim, this.httpOptions);
  }

  public deleteDraft(draftDelete: DeleteDraft): Observable<any> {
    const httpDelOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: draftDelete
    };

    return this.http.delete<any>(`${environment.baseUrl.api}${ApiEndpoints.deleteDraft}`, httpDelOptions);
  }

  public getMetaData(): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl.api}${ApiEndpoints.getMetaData}`, this.httpOptions);
  }

  public uploadDocument(file: FormData): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl.api}${ApiEndpoints.uploadDocument}`, file);
  }

  public generateUploadToken(): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl.api}${ApiEndpoints.generateUploadToken}`, this.httpOptions);
  }

  public uploadFile(files: File[], userData: any): Observable<any> {
    const formData = new FormData();
    
    // Append all files
    for (let file of files) {
      formData.append('files', file);
    }
    
    // Append user data fields matching the original solution's form-data payload
    // Note: Property names must match exactly what the backend controller expects
    if (userData) {
      formData.append('UserData.PolicyNo', userData.policyNumber || userData.policyNo || '');
      formData.append('UserData.PayeeID', userData.payeeId || userData.payeeID || '');
      formData.append('UserData.UserName', userData.userName || userData.firstName || '');
      formData.append('UserData.PayeeName', userData.payeeName || '');
      formData.append('UserData.GroupCode', userData.groupCode || '');
      formData.append('UserData.ClaimSource', userData.claimSource || '');
    }
    
    return this.http.post<any>(`${environment.baseUrl.api}${ApiEndpoints.uploadFile}`, formData);
  }

  public updateClaimDetails(claimPayload: any): Observable<IUpdateClaimDetailsResponse> {
    return this.http.post<IUpdateClaimDetailsResponse>(`${environment.baseUrl.api}${ApiEndpoints.updateClaimDetails}`, claimPayload, this.httpOptions);
  }

  public validateClaims(claimFileId: number | string, payload?: IValidateClaimsRequest): Observable<IValidateClaimsResponse> {
    return this.http.post<IValidateClaimsResponse>(
      `${environment.baseUrl.api}${ApiEndpoints.validateClaims}?claimFileId=${encodeURIComponent(String(claimFileId ?? ''))}`,
      payload || {},
      this.httpOptions
    );
  }

  public uploadDocumentClaims(payload: IUploadDocumentRequest): Observable<IUploadDocumentResponse> {
    return this.http.post<IUploadDocumentResponse>(
      `${environment.baseUrl.api}${ApiEndpoints.uploadDocumentClaims}`,
      payload,
      this.httpOptions
    ).pipe(
      map((response) => {
        if (typeof response === 'string') {
          try {
            return JSON.parse(response);
          } catch {
            return response as any;
          }
        }

        return response;
      })
    );
  }

  public submitClaimsGwcc(payload: ISubmitClaimRequest): Observable<ISubmitClaimResponse> {
    return this.http.post<ISubmitClaimResponse>(
      `${environment.baseUrl.api}${ApiEndpoints.submitClaimsGwcc}`,
      payload,
      this.httpOptions
    );
  }

  public uploadSubDocument(claimId: number | string, file: File): Observable<IUploadSubDocumentResponse> {
    const formData = new FormData();
    // Browsers often leave file.type empty/unknown for .heic - correct it (and .msg) like upsc-document-upload does, so the backend recognizes the file.
    const mimeType = file.name.toLowerCase().endsWith('.msg') ? 'application/vnd.ms-outlook'
      : file.name.toLowerCase().endsWith('.heic') ? 'image/heic'
      : file.type;
    const uploadFile = mimeType !== file.type ? new File([file], file.name, { type: mimeType }) : file;
    formData.append('file', uploadFile, uploadFile.name);

    return this.http.post<IUploadSubDocumentResponse>(
      `${environment.baseUrl.api}${ApiEndpoints.uploadSubDocument}/${encodeURIComponent(String(claimId || ''))}`,
      formData
    );
  }

  public deleteSubDocument(publicId: number | string): Observable<IDeleteSubDocumentResponse> {
    return this.http.delete<IDeleteSubDocumentResponse>(
      `${environment.baseUrl.api}${ApiEndpoints.deleteSubDocument}/${encodeURIComponent(String(publicId || ''))}`,
      this.httpOptions
    );
  }

  public formatAmount(event, backspace: boolean) {
    var plainNumber = event.replace(/[^-+0-9]/g, '');
    plainNumber = this.number.transform(plainNumber / 100, '1.2-2').replace(/,/g, '');
    return plainNumber;
  }

  public removeDocument(file): Observable<any> {
    //Include the body in options for delete requests
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        publicID: file?.publicID
      }
    };
    return this.http.delete<any>(`${environment.baseUrl.api}${ApiEndpoints.removeDocument}`, httpOptions);
  }

  public getShipmentDetails(id: string): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl.api}${ApiEndpoints.getShipmentDetails}${id}`, this.httpOptions);
  }

  public getUserLayout(layout: GetUserLayout): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl.api}${ApiEndpoints.getUserLayouts}`, layout, this.httpOptions);
  }

  public removeUserLayout(layout: removeUserLayout): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl.api}${ApiEndpoints.removeUserLayouts}`, layout, this.httpOptions);
  }

  public getUserLayoutDetails(layout: GetUserLayoutDetails): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl.api}${ApiEndpoints.getUserLayoutcolumns}`, layout, this.httpOptions);
  }

  public submitUserLayoutDetails(layout: ILayoutDetails): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl.api}${ApiEndpoints.submitUserLayoutcolumns}`, layout, this.httpOptions);
  }

  public getRedirect(details: RedirectDetails): Observable<any> {
    if (this.userService.isDDClaimsFlow() && this.router.url.startsWith('/claims')) {
      details = { ...details, tupssFlow: 'DD', scenario: 'tupss' };
    }
    return this.http.post<any>(`${environment.baseUrl.api}${ApiEndpoints.getRedirect}`, details, this.httpOptions);
  }

  public getPayeeDetails(req): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl.api}${ApiEndpoints.getPayeeDetails}`, req, this.httpOptions);
  }

  public checkDuplicateClaims(id: string): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl.api}${ApiEndpoints.CHECK_CLAIMS}${id}`, this.httpOptions);
  }

  public getAllClaimIds(summery: ISummary): Observable<ClaimIdsModel> {
    let shopifyUID = this.userService.getshopifyUserObjectUID();
    if (shopifyUID !== null) {
      summery.objectUID = shopifyUID;
    }
    return this.http.post<ClaimIdsModel>(`${environment.baseUrl.api}${ApiEndpoints.getAllClaimIds}`, summery, this.httpOptions);
  }

  public getAllMessageClaimIDs(summary: ISummary): Observable<MessageClaimIdsModel> {
    let shopifyUID = this.userService.getshopifyUserObjectUID();
    if (shopifyUID !== null) {
      summary.objectUID = shopifyUID;
    }
    return this.http.post<MessageClaimIdsModel>(`${environment.baseUrl.api}${ApiEndpoints.getAllMessageClaimIds}`, summary, this.httpOptions);
  }

  public getAllMessageIDs(summary: IMsgSummary): Observable<MessageIdsModel> {
    return this.http.post<MessageIdsModel>(`${environment.baseUrl.api}${ApiEndpoints.getAllMessageIds}`, summary, this.httpOptions);
  }

  public getClaimByIds(policyNumber: string, claimIds: string[], isParentPolicy?: boolean, contractNumber?: string): Observable<ClaimListModel> {
    const endpoint = `${environment.baseUrl.api}${ApiEndpoints.getClaimSummary}`;
    let shopifyUID = this.userService.getshopifyUserObjectUID();
    if (shopifyUID !== null) {
      return this.http.post<ClaimListModel>(endpoint, { policyNumber: policyNumber, claimNumbers: claimIds, objectUID: shopifyUID, contractNumber: contractNumber }, this.httpOptions);
    }
    else {
      return this.http.post<ClaimListModel>(endpoint, { policyNumber: policyNumber, claimNumbers: claimIds, isParentPolicy: isParentPolicy, contractNumber: contractNumber }, this.httpOptions);
    }
  }

  getClaimSummary(request): Observable<ClaimListModel> {
    return this.http.post<ClaimListModel>(`${environment.baseUrl.api}${ApiEndpoints.getClaimSummary}`, request, this.httpOptions);
  }

  public getMessageSummaryByIds(policyNumber: string, claimIds: string[], isParentPolicy?: boolean, contractNumber?: string): Observable<MessageListModel> {
    const endpoint = `${environment.baseUrl.api}${ApiEndpoints.getMessageSummary}`;
    let shopifyUID = this.userService.getshopifyUserObjectUID();
    if (shopifyUID !== null) {
      return this.http.post<MessageListModel>(endpoint, { policyNumber: policyNumber, claimNumbers: claimIds, objectUID: shopifyUID, contractNumber: contractNumber }, this.httpOptions);
    }
    else {
      return this.http.post<MessageListModel>(endpoint, { policyNumber: policyNumber, claimNumbers: claimIds, isParentPolicy: isParentPolicy, contractNumber }, this.httpOptions);
    }
  }

  getMessageIDsSummary(request) {
    return this.http.post<MessageListModel>(`${environment.baseUrl.api}${ApiEndpoints.getMessageSummary}`, request, this.httpOptions);
  }

  public getMsgDetailsByIds(policyNumber: string, message: string, claimNumber: string, messageIds: string[]): Observable<MessageListModel> {
    return this.http.post<MessageListModel>(`${environment.baseUrl.api}${ApiEndpoints.getMessageDetails}`, {
      policyNumber: policyNumber, message: message, claimNumber: claimNumber,
      messageIds: messageIds
    }, this.httpOptions);

  }

  public getShipmentDetailsAutofill(id: string, subpath?: string): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl.api}${ApiEndpoints.getShipmentDetailsAutofill}${id}${subpath ? `/${subpath}` : ''}`);
  }

  public getClaimDetails(claimNumber: string, policyNumber: string): Observable<any> {
    const endpoint = `${environment.baseUrl.api}${ApiEndpoints.getClaimsDetails}`;
    let shopifyUID = this.userService.getshopifyUserObjectUID();
    if (shopifyUID !== null) {
      return this.http.get<any>(endpoint + "/claimNum/" + claimNumber + "/policyNum/" + policyNumber + "?" + "objectUID=" + shopifyUID, this.httpOptions);
    } else {
      return this.http.get<any>(endpoint + "/claimNum/" + claimNumber + "/policyNum/" + policyNumber, this.httpOptions);
    }
  }

  public getClaimDispute(request): Observable<any> {
    return this.http.post<MessageListModel>(`${environment.baseUrl.api}${ApiEndpoints.CLAIM_AUTO_CLOSER_DISPUTES}`, request, this.httpOptions);
  }//CRE claim Auto closer and disputes
  
  // Unused API
  // public getClaims(claimNumber: string,) {
  //   return this.http.get<any>(`${environment.baseUrl.api}${ApiEndpoints.getClaims}${claimNumber}`, this.httpOptions);
  // }
  
  public getReporterClaims(payload): Observable<any> {
    return this.http.post<any>(
      `${environment.baseUrl.api}${ApiEndpoints.TCCP_CLAIMS}`,
      { "reporterEmail": payload.reporterEmail, "claimSource": payload.claimSource },
      this.httpOptions
    );
  }

  downloadDocument(id: string, policyNumber: string): Observable<any> {
    let options = { 'responseType': 'arraybuffer' as 'json' }
    let shopifyUID = this.userService.getshopifyUserObjectUID();
    if (shopifyUID !== null) {
      return this.http.get<any>(`${environment.baseUrl.api}${ApiEndpoints.downloadDocument}/` + id + "/policyNum/" + policyNumber + "?" + "objectUID=" + shopifyUID, options);
    }
    else {
      return this.http.get<any>(`${environment.baseUrl.api}${ApiEndpoints.downloadDocument}/` + id + "/policyNum/" + policyNumber, options);
    }
  }

  addressValidation(body) {
    return this.http.post<any>(`${environment.baseUrl.api}${ApiEndpoints.ADDRESS_VALIDATION}`, body, this.httpOptions);
  }

  setAddValData(data) {
    this.addressValidationData.next(data);
  }

  getAddValData() {
    return this.addressValidationData;
  }

  setTupssAddress(data) {
    this.tupssEnteredAddress.next(data);
  }

  getTupssAddress() {
    return this.tupssEnteredAddress;
  }

  setLoading(bool) {
    this.loading.next(bool);
  }

  getLoading() {
    return this.loading;
  }

  setIsClaimSearchCompleted(bool: boolean) {
    this.isClaimSearchCompleted.next(bool);
  }

  getIsClaimSearchCompleted() {
    return this.isClaimSearchCompleted;
  }

  getiShipData(payload) {
    return this.http.post<any>(`${environment.baseUrl.api}${ApiEndpoints.ISHIP}`, payload, this.httpOptions).pipe(
      map((res) => {
        let zipCode = res.data?.response?.cdsresponse?.shipmentInfo?.fromAddress?.postal;
        if (zipCode) {
          if (zipCode.length > 5) {
            zipCode = `${zipCode.substring(0, 5)}-${zipCode.substring(5)}`;
          }
          res.data.response.cdsresponse.shipmentInfo.fromAddress.postal = zipCode;
        }
        let toAddressZip = res.data?.response?.cdsresponse?.shipmentInfo?.toAddress?.postal;
        if (toAddressZip) {
          if (toAddressZip.length > 5) {
            toAddressZip = `${toAddressZip.substring(0, 5)}-${toAddressZip.substring(5)}`;
          }
          res.data.response.cdsresponse.shipmentInfo.toAddress.postal = toAddressZip;
        }
        return res;
      })
    );
  }

  getSSPClaimStats(request) {
    console.log("Duplicate API calls Method 1", this.currentPartner);
    if ((this.currentPartner !== 'SSP') && (this.currentPartner !== 'CCP')) { //getClaimStats Duplicate API calls
      return this.http.post<any>(`${environment.baseUrl.api}${ApiEndpoints.CLAIM_STATS}`, request, this.httpOptions);
    }
  }

  getClaimStats(policyNumber: string, groupCode: string) {
    //Building the request here
    //Default / child:
    let request;

    if (groupCode.length > 0) {
      request = {
        policyNumber: policyNumber,
        groupCode: groupCode,
        contractNumber: this.policyService.isCLMS() ? this.loginService.getPolicyDetails().ref6 : ''
      }
    } else {
      request = {
        policyNumber: policyNumber,
        contractNumber: this.policyService.isCLMS() ? this.loginService.getPolicyDetails().ref6 : ''
      }
    }

    //Parent:
    if (this.userService.isParentPolicy()) {
      request = { ...request, childParentPolicies: JSON.parse(sessionStorage.getItem('childPolicies')) }
    }

    //Shipper:
    if (this.userService.getUserInfo().groupID) {
      request = { ...request, groupID: this.userService.getUserInfo().groupID }
    }
    console.log("Duplicate API calls Method 2 getClaimStats() Ln:336", this.currentPartner);
    //getClaimStats Duplicate API calls
    return this.http.post<ClaimStats>(`${environment.baseUrl.api}${ApiEndpoints.CLAIM_STATS}`, request);
  }

  setLocaliShipData(data) {
    this.iShipData.next(data);
  }

  getLocaliShipData() {
    return this.iShipData;
  }

  setTupssClaimData(data) {
    //Set the pre vs post to POST
    sessionStorage.setItem('userDetails', JSON.stringify({ ...JSON.parse(sessionStorage.getItem('userDetails')), stage: 'post' }));
    this.tupssClaimData.next(data);
  }

  getTupssClaimData() {
    return this.tupssClaimData;
  }

  postMessage(request) {
    return this.http.post<any>(`${environment.baseUrl.api}${ApiEndpoints.POST_MESSAGE}`, request, this.httpOptions);
  }

  isSearchingPackage(claim) {
    if (claim?.adjuster?.displayName?.toLowerCase() == 'aging user') {
      const claimState = claim.claimState?.toLowerCase();
      const claimSubStatus = claim.claimSubStatus?.toLowerCase().replace(/[\s_-]/g, '');

      if (claimState == 'open' && claimSubStatus == 'submitted') {
        return true;
      }
      else {
        return false;
      }
    }
    else {
      return false;
    }
  }

  isPendingConfirmation(claim) {
    /* if(claim?.adjuster?.displayName?.toLowerCase() == 'aging user') {
      if(claim.claimState?.toLowerCase() == 'closed' && claim.claimSubStatus?.toLowerCase() == 'deliveryconfirmationpending') {
        return true;
      }
      else {
        return false;
      }
    }
    else {
      return false;
    } */
    if (claim.claimState?.toLowerCase() == 'closed' && claim.claimSubStatus?.toLowerCase() == 'deliveryconfirmationpending') {
      return true;
    }
    else {
      return false;
    }
  }

  setDeliveryStatus(request) {
    return this.http.post<any>(`${environment.baseUrl.api}${ApiEndpoints.DELIVERY_STATS}`, request, this.httpOptions);
  }

  sendMyChoiceClaimSubmissionEmail(request) {
    return this.http.post<any>(`${environment.baseUrl.api}${ApiEndpoints.MYCHOICE_CLAIM_SUBMISSION_EMAIL}`, request, this.httpOptions);
  }
  sendMyChoicePaymentReceiptEmail(request) {
    return this.http.post<any>(`${environment.baseUrl.api}${ApiEndpoints.MYCHOICE_PAYMENT_RECEIPT_EMAIL}`, request, this.httpOptions);
  }

  myChoiceZipValidate(request) {
    return this.http.post<any>(`${environment.baseUrl.api}${ApiEndpoints.MYCHOICE_ZIP_VALIDATION}`, request, this.httpOptions);
  }

  // sendCCPClaimSubmissionEmail(request) {//STOP ACK Letter 2026
  //   return this.http.post<any>(`${environment.baseUrl.api}${ApiEndpoints.CCP_CLAIM_SUBMISSION_EMAIL}`, request, this.httpOptions);
  // }

  // sendClaimSubmissionEmail(request) {//STOP ACK Letter 2026
  //   return this.http.post<any>(`${environment.baseUrl.api}${ApiEndpoints.CCP_CLAIM_SUBMISSION_EMAIL}`, request, this.httpOptions);
  // }

  sendCCPVerificationCodeEmail(request) {
    return this.http.post<any>(`${environment.baseUrl.api}${ApiEndpoints.CCP_VERIFICATION_CODE_EMAIL}`, request, this.httpOptions);
  }

  //Input: partner name and policy number
  //Output: "Match" or not, checks our database tables for match
  checkCCPPolicy(request) {
    return this.http.post<any>(`${environment.baseUrl.api}${ApiEndpoints.CHECK_CCP_POLICY}`, request, this.httpOptions);
  }

  // sendAcknowledgementLetter(request) {
  //   return this.http.post<any>(`${environment.baseUrl.api}${ApiEndpoints.SEND_ACK_EMAIL}`, request, this.httpOptions);
  // }

  sendInternationalAcknowledgementLetter(request) {
    return this.http.post<any>(`${environment.baseUrl.api}${ApiEndpoints.SEND_ACK_INTERNATIONAL_EMAIL}`, request, this.httpOptions);
  }


  //getting parameters necessary for portalBanners API call (only one is required)

  getPolicyBanners(portalType: string, policyNumber: string, partnerName: string, countryLocale: string = 'en'): Observable<any> {
    // query parameters
    const params: any = {};
    if (portalType) {
      params.portalType = portalType;
    }
    if (policyNumber) {
      params.policyNumber = policyNumber;
    }
    if (partnerName) {
      params.partnerName = partnerName;
    }

    if(countryLocale){
       params.countryLocale = countryLocale;
    }


    // Convert params to URL query string
    const queryString = Object.keys(params)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
      .join('&');

    //API call
    return this.http.get<any>(
      `${environment.baseUrl.api}${ApiEndpoints.getPolicyBanners}${queryString ? '?' + queryString : ''}`,
      this.httpOptions
    );
  }

  validateCCPTrackingNumber(trackingNumber, channelPartnerName) {
    let endpoint = `${environment.baseUrl.api}${ApiEndpoints.CCP_TN_VALIDATION}`;
    let request = {
      trackingNum: trackingNumber,
      isInXpress: channelPartnerName == 'inxpress' ? true : false,
      partnerFlow: channelPartnerName == 'pirate-ship' ? 0 : 1
    }
    return this.http.post<any>(`${endpoint}`, request, this.httpOptions);
  }
}
